import { api } from '../../lib/api';

// After a booking write, replace the CACHED single-booking reads so the next
// modal open reflects the change immediately. The GETs (/bookings/:id and
// /:id/context) stay cacheable for a fast open→close→reopen; this `cache: reload`
// refetch is the only thing that busts the stale copy — the read-cache-strategy
// "editor's own edit" write-revalidation the AP3 disposition always assumed but
// was never wired for the modal hydrate (so a save→reopen served stale).
//
// Returns the settle promise: a caller that must guarantee freshness before it
// acts (the modal save, before it closes) AWAITS it; a desk status/payment
// toggle that just keeps the cache warm fires it `void` (fire-and-forget).
export function revalidateBooking(id: string, fetchFn?: typeof fetch): Promise<unknown> {
  const opts = { cache: 'reload' as RequestCache, ...(fetchFn ? { fetchFn } : {}) };
  return Promise.all([
    api(`/bookings/${id}`, opts).catch(() => undefined),
    api(`/bookings/${id}/context`, opts).catch(() => undefined),
  ]);
}
